import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBank,
  faBuilding,
  faCartShopping,
  faFlask,
  faGamepad,
  faGlobe,
  faGavel,
  faHospital,
  faIndustry,
  faPills,
  faStore,
  faTicket,
} from '@fortawesome/free-solid-svg-icons';

const Industries = () => {
  const industries = [
    { icon: faHospital, name: 'Healthcare' },
    { icon: faGavel, name: 'Legal' },
    { icon: faBank, name: 'Banking' },
    { icon: faPills, name: 'Pharma' },
    { icon: faFlask, name: 'Chemical' },
    { icon: faIndustry, name: 'Manufacturing' },
    { icon: faStore, name: 'Retail & E-com' },
    { icon: faGamepad, name: 'E-Sports' },
    { icon: faTicket, name: 'Events' },
    { icon: faBuilding, name: 'Enterprise' },
    { icon: faCartShopping, name: 'Shopify Stores' },
    { icon: faGlobe, name: 'Global Businesses' }
  ];

  return (
    <section id="industries" className="industries-section">
      <div className="section-container">
        <div className="section-header reveal">
          <div className="section-label">Industries</div>
          <h2 className="section-title">Built for Every Industry</h2>
          <p className="section-description">
            Context to Call powers customer communication across healthcare, legal, banking, retail and beyond.
          </p>
        </div>
        
        <div className="industries-grid reveal">
          {industries.map((industry, index) => (
            <div key={index} className="industry-card">
              <span className="industry-icon">
                <FontAwesomeIcon icon={industry.icon} />
              </span>
              <p>{industry.name}</p>
            </div>
          ))}
        </div>
        
        <div className="global-banner reveal">
          <p>
            <strong>Supported in 112+ countries</strong> — Delivering seamless customer experiences across borders. 
            C2C is built for truly global businesses.
          </p>
          <div className="country-tags">
            <span className="country-tag">🇺🇸 USA</span>
            <span className="country-tag">🇬🇧 UK</span>
            <span className="country-tag">🇮🇳 India</span>
            <span className="country-tag">🇩🇪 Germany</span>
            <span className="country-tag">🇫🇷 France</span>
            <span className="country-tag">🇧🇷 Brazil</span>
            <span className="country-tag">🇦🇺 Australia</span>
            <span className="country-tag">🇯🇵 Japan</span>
            <span className="country-tag">🇸🇬 Singapore</span>
            <span className="country-tag">🇦🇪 UAE</span>
            <span className="country-tag">+ 102 more</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Industries;
